import { MarkInProgressProps } from "@/common/types";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { updateKitStatus } from "@/redux/actions/testKitActions";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const MarkInProgress: React.FC<MarkInProgressProps> = ({
  testKitId,
  callback,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const params = useParams();
  const dispatch: any = useDispatch();

  const handleSubmit = () => {
    const payload = {
      status: "IN_PROGRESS",
    };
    const kitId = testKitId ? testKitId : Number(params.id);
    dispatch(
      updateKitStatus(Number(kitId), payload, () => {
        setIsOpen(false);
        if (callback) {
          callback();
        }
      })
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary">Mark In Progress</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Mark In Progress</DialogTitle>
          <DialogDescription>
            Mark the status of the test kit as in progress.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="submit" onClick={() => handleSubmit()}>
            Mark In Progress
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MarkInProgress;
